var _defs, _g, _g2, _g3, _g4, _g5, _rect, _rect2, _rect3, _g6, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResized2024MichelinPartnershipLogoLockup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229 118.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.4,105.5c.4.3.9.4,1.5.4s1.5-.4,1.5-1.4-3.1-1.5-3.1-3.3,1-1.8,2.2-1.8.9,0,1.3.2v.6c-.4-.2-.9-.3-1.4-.3-.7,0-1.5.3-1.5,1.2,0,1.4,3.1,1.4,3.1,3.4s-1.2,1.9-2.3,1.9-1.2-.1-1.6-.3v-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.4,99.5h.7v6.9h-.7v-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.5,99.5h.9l3.5,6h0v-6h.7v6.9h-.9l-3.4-5.9h0v5.9h-.7v-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.9,103.3h-1.6v-.6h2.3v3.4c-.7.3-1.4.4-2.1.4-2.2,0-3.5-1.4-3.5-3.5s1.3-3.5,3.5-3.5,1.4,0,1.8.3v.6c-.6-.3-1.2-.4-1.8-.4-1.8,0-2.8,1.3-2.8,3s1,3,2.8,3,1.1,0,1.5-.2v-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.3,99.5h.8l2.7,6.9h-.7l-.7-1.8h-3.5l-.7,1.8h-.7l2.8-6.9ZM41.7,100.2l-1.5,3.8h3l-1.5-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.8,99.5h1.7c1.3,0,2.1.6,2.1,1.9s-1,1.9-2.2,1.9h-.9v3h-.7v-6.9ZM47.4,102.8h.5c1,0,2-.1,2-1.4s-.5-1.4-1.4-1.4h-1.1v2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.4,99.4c2.1,0,3,1.7,3,3.5,0,2.1-1,3.5-3,3.5s-3-1.4-3-3.5c0-1.9,1-3.5,3-3.5ZM53,103c0,1.5.7,3,2.3,3s2.3-1.5,2.3-3-.7-3-2.3-3-2.3,1.5-2.3,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.8,99.5h1.8c1.2,0,2,.5,2,1.8s-.7,1.5-1.5,1.6h0c.6,0,.7.4.9.8l1.2,2.7h-.7l-1-2.3c-.4-.9-.7-.9-1.3-.9h-.6v3.2h-.7v-6.9ZM61.4,102.6h.7c.8,0,1.7-.3,1.7-1.3s-.8-1.2-1.7-1.2h-.7v2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.2,99.5h3.4v.6h-2.7v2.4h2.5v.6h-2.5v2.6h2.8v.6h-3.5v-6.9Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29,78.3v-1.1c.6-.6,3-2.6,3-3.8s-.6-.9-1.1-.9-1.1.3-1.6.5v-1.1c.5-.3,1.2-.5,1.9-.5,1.3,0,2.2.7,2.2,2s-1.5,2.8-2.6,3.9h2.8v1.1h-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.4,74.9c0-1.7.5-3.6,2.4-3.6s2.4,2,2.4,3.6-.4,3.5-2.4,3.5-2.4-2.1-2.4-3.5ZM39.8,74.9c0-.9,0-2.5-1-2.5s-1,1.7-1,2.5,0,2.5,1,2.5,1-1.6,1-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.9,78.3v-1.1c.6-.6,3-2.6,3-3.8s-.6-.9-1.1-.9-1.1.3-1.6.5v-1.1c.5-.3,1.2-.5,1.9-.5,1.3,0,2.2.7,2.2,2s-1.5,2.8-2.6,3.9h2.8v1.1h-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.1,75.8l2.6-4.3h1.7v4.4h.9v1h-.9v1.4h-1.3v-1.4h-3v-1.1ZM54,75.8v-3h0l-1.7,3h1.7Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,50.7h3.7l2.7,9h0l2.7-9h3.7v11.8h-2.2v-9.7h0l-3.1,9.7h-2.2l-3.1-9.7h0v9.7H0v-11.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17,50.7h2.3v11.8h-2.3v-11.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.8,62.4c-.8.2-1.7.4-2.6.4-3.7,0-6.3-1.9-6.3-5.9s2.4-6.3,6.3-6.3,1.8.2,2.6.5l-.2,2c-.9-.5-1.7-.6-2.5-.6-2.4,0-3.9,1.9-3.9,4.3s1.5,4.2,3.9,4.2,2-.2,2.5-.5v2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.1,50.7h2.3v4.8h4.6v-4.8h2.3v11.8h-2.3v-5.2h-4.6v5.2h-2.3v-11.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.7,50.7h6.8v1.9h-4.5v2.9h4.1v1.9h-4.1v3.3h4.5v1.9h-6.8v-11.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.5,50.7h2.3v10h4.5v1.9h-6.8v-11.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.2,50.7h2.3v11.8h-2.3v-11.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.5,50.7h2.8l4.4,8.8h0v-8.8h2.2v11.8h-2.8l-4.4-8.8h0v8.8h-2.2v-11.8Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.5,15.7c0-1-.2-2-.6-2.9l-2,1c.2.6.4,1.2.4,1.9,0,3.4-3.6,5.5-10.9,6.1v1.2c7.3.6,10.9,2.7,10.9,6.1s-.5,2.5-1.4,3.5c-.9,1-1.9,1.5-3,1.5-2.7,0-5.7-2.4-8.8-7.1l-1.1.6c1.6,3.3,2.3,6.1,2.3,8.3,0,3.4-1.5,5.1-4.6,5.1s-2.6-.5-3.4-1.4c-.8-.9-1.2-2.1-1.2-3.7,0-2.3.8-5.1,2.3-8.4l-1.1-.6c-3.2,4.7-6.1,7.1-8.8,7.1s-2.2-.5-3.1-1.6c-.9-1-1.3-2.2-1.3-3.4,0-3.4,3.6-5.5,11-6.1v-1.2c-7.3-.6-11-2.7-11-6.1s.5-2.5,1.4-3.5c.9-1,1.9-1.5,3-1.5,2.8,0,5.7,2.4,8.8,7.1l1.1-.6c-1.6-3.3-2.3-6.1-2.3-8.3s.4-2.7,1.2-3.7c.5-.6,1.2-1,2-1.2l-.2-2.2c-1.2.3-2.2.9-3.1,1.8-1.3,1.3-1.9,3-1.9,5.1v2l-.6-.4c-1.6-1.2-3.3-1.8-4.9-1.8s-3.4.7-4.7,2.2c-1.3,1.5-2,3.1-2,5,0,2.8,1.8,5.1,5.4,6.8l-.6.3c-3.2,1.5-4.8,3.6-4.8,6.4s.2,1.9.6,2.8c.5,1.2,1.3,2.3,2.4,3.2,1.1.9,2.3,1.3,3.6,1.3s3.5-.7,5.5-2.2v1.7c0,2.3.6,4.1,1.8,5.4,1.2,1.4,2.8,2.1,5,2.1s3.6-.7,4.8-2c1.3-1.3,1.9-3,1.9-5.1v-2.1l.5.5c1.4,1.2,3,1.8,4.9,1.8s3.4-.7,4.6-2.2c1.3-1.5,1.9-3.2,1.9-5,0-2.8-1.8-5-5.4-6.7l.6-.3c3.2-1.5,4.8-3.6,4.8-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.6,16.2l-.7-.3s-2.4-8.8-2.3-10.9c0-1.4.9-2.8,2.1-3.5,1.2-.7,2.7-.7,4.1,0,1.6.9,2,2.7,2,4.1,0,0,.2-.1.3-.2,1.4-1,2.8-1.2,4.1-.6,1.3.7,2.1,1.9,2.2,3.4,0,1.5-.5,3-1.6,3.8-2.6,1.9-10.1,4.2-10.1,4.2Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.9,88.1c0-.2,0-.5-.1-.7l-.5.2c0,.1,0,.3,0,.4,0,.8-.9,1.3-2.6,1.5v.3c1.7.2,2.6.6,2.6,1.5s-.1.6-.3.8c-.2.2-.5.4-.7.4-.6,0-1.3-.6-2.1-1.7h-.3c.4.9.6,1.6.6,2.1,0,.8-.4,1.2-1.1,1.2s-.6-.1-.8-.3c-.2-.2-.3-.5-.3-.9,0-.5.2-1.2.6-2h-.3c-.8,1-1.5,1.5-2.1,1.5s-.5-.1-.7-.4c-.2-.2-.3-.5-.3-.8,0-.8.9-1.3,2.6-1.5v-.3c-1.7-.1-2.6-.6-2.6-1.5s.1-.6.3-.8c.2-.2.5-.4.7-.4.7,0,1.4.6,2.1,1.7h.3c-.4-.9-.6-1.6-.6-2.1s0-.7.3-.9c.1-.1.3-.2.5-.3v-.5c-.3,0-.6.2-.8.4-.3.3-.5.7-.5,1.2v.5h-.1c-.4-.4-.8-.5-1.2-.5s-.8.2-1.1.5c-.3.3-.5.7-.5,1.2,0,.7.4,1.2,1.3,1.6h-.1c-.8.4-1.1.9-1.1,1.6s0,.5.1.7c.1.3.3.5.6.7.3.2.6.3.9.3s.8-.2,1.3-.5v.2h0v.2c0,.5.1,1,.4,1.3.3.3.7.5,1.2.5s.8-.2,1.2-.5c.3-.3.5-.7.5-1.2v-.5h.1c.3.4.7.5,1.2.5s.8-.2,1.1-.5c.3-.4.5-.7.5-1.2,0-.7-.4-1.2-1.3-1.6h.1c.8-.4,1.1-.9,1.1-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.4,88.3h-.2c0,0-.6-2.2-.5-2.7,0-.3.2-.7.5-.8.3-.2.6-.2,1,0,.4.2.5.6.5,1,0,0,0,0,0,0,.3-.2.7-.3,1-.1.3.2.5.5.5.8,0,.4-.1.7-.4.9-.6.4-2.4,1-2.4,1Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.2,
    y: 89.6,
    width: 22.6,
    height: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 100.3,
    y: 94.2,
    width: 0.4,
    height: 13.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 100.3,
    y: 1.1,
    width: 0.4,
    height: 83.5
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.9,99.4c2.1,0,3,1.7,3,3.5,0,2.1-1,3.5-3,3.5s-3-1.4-3-3.5c0-1.9,1-3.5,3-3.5ZM129.5,103c0,1.5.7,3,2.3,3s2.3-1.5,2.3-3-.7-3-2.3-3-2.3,1.5-2.3,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.1,99.5h3.3v.6h-2.6v2.4h2.5v.6h-2.5v3.2h-.7v-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.5,99.5h3.3v.6h-2.6v2.4h2.5v.6h-2.5v3.2h-.7v-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.8,99.5h.7v6.9h-.7v-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M159.7,100.3c-.4-.2-1.1-.3-1.5-.3-1.8,0-2.8,1.3-2.8,3s1,3,2.8,3,1.1,0,1.5-.3v.6c-.3.2-1.1.3-1.5.3-2.2,0-3.5-1.4-3.5-3.5s1.3-3.5,3.5-3.5,1.2,0,1.6.3v.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.4,99.5h.7v6.9h-.7v-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M169.8,99.5h.8l2.7,6.9h-.7l-.7-1.8h-3.5l-.7,1.8h-.7l2.8-6.9ZM170.1,100.2l-1.5,3.8h3l-1.5-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.1,99.5h.7v6.3h2.8v.6h-3.4v-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.2,99.5h1.6c1.1,0,2.2.4,2.2,1.7s-.4,1.4-1.2,1.6h0c.9.2,1.5.7,1.5,1.7,0,1.5-1.2,2-2.6,2h-1.4v-6.9ZM187.8,105.8h.7c.9,0,1.9-.2,1.9-1.3s-1.1-1.3-2.1-1.3h-.6v2.7ZM187.8,102.5h.8c.7,0,1.7-.2,1.7-1.3s-.9-1.1-1.5-1.1h-.9v2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196.7,99.5h.8l2.7,6.9h-.7l-.7-1.8h-3.5l-.7,1.8h-.7l2.8-6.9ZM197.1,100.2l-1.5,3.8h3l-1.5-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.1,99.5h.9l3.5,6h0v-6h.7v6.9h-.9l-3.4-5.9h0v5.9h-.7v-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.8,99.5h.7v3.1l3.1-3.1h.9l-3.3,3.2,3.6,3.6h-.9l-3.3-3.4v3.4h-.7v-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148.5,111.3h1.7c1.3,0,2.1.6,2.1,1.9s-1,1.9-2.2,1.9h-.9v3h-.7v-6.9ZM149.2,114.6h.5c1,0,2-.1,2-1.4s-.5-1.4-1.4-1.4h-1.1v2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.7,111.3h.8l2.7,6.9h-.7l-.7-1.8h-3.5l-.7,1.8h-.7l2.8-6.9ZM157.1,112l-1.5,3.8h3l-1.5-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.2,111.3h1.8c1.2,0,2,.5,2,1.8s-.7,1.5-1.5,1.6h0c.5,0,.7.4.9.8l1.2,2.7h-.7l-1-2.3c-.4-.9-.7-.9-1.3-.9h-.6v3.2h-.7v-6.9ZM163.8,114.3h.7c.8,0,1.7-.3,1.7-1.3s-.8-1.2-1.7-1.2h-.7v2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.9,111.9h-2v-.6h4.7v.6h-2v6.3h-.7v-6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.4,111.3h.9l3.5,6h0v-6h.7v6.9h-.9l-3.4-5.9h0v5.9h-.7v-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M186,111.3h3.4v.6h-2.7v2.4h2.5v.6h-2.5v2.6h2.8v.6h-3.5v-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.9,111.3h1.8c1.2,0,2,.5,2,1.8s-.7,1.5-1.5,1.6h0c.5,0,.7.4.9.8l1.2,2.7h-.7l-1-2.3c-.4-.9-.7-.9-1.3-.9h-.6v3.2h-.7v-6.9ZM193.6,114.3h.7c.8,0,1.7-.3,1.7-1.3s-.8-1.2-1.7-1.2h-.7v2.4Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 161.3,
    y: 89.6,
    width: 22.6,
    height: 0.4
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.4,58.5v-7.5h1.7v7.5c0,3,1.2,4.3,3.4,4.3s3.4-1.2,3.4-4.3v-7.5h1.7v7.5c0,3.9-1.7,5.8-5.1,5.8s-5.1-1.8-5.1-5.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "142.7 51 142.7 62.5 148.6 62.5 148.6 64.1 141 64.1 141 51 142.7 51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "160.6 52.6 156.4 52.6 156.4 51 166.4 51 166.4 52.6 162.3 52.6 162.3 64.1 160.6 64.1 160.6 52.6"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 177.4,
    y: 51,
    width: 1.7,
    height: 13.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "191.6 51 193.9 51 198 62.6 202.2 51 204.4 51 204.4 64.1 202.8 64.1 202.8 53.5 199 64.1 197 64.1 193.2 53.5 193.2 64.1 191.6 64.1 191.6 51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.2,58.8l-2.1-6.2-2.1,6.2h4.3ZM220,51h2l4.7,13.1h-1.7l-1.3-3.7h-5.4l-1.3,3.7h-1.8l4.7-13.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M180.3,13.7c5.5,0,10.3,2.7,13.3,6.9h-3.7c-2.4-2.6-5.7-4.3-9.6-4.3s-7.2,1.6-9.6,4.3h-3.7c3-4.2,7.8-6.9,13.3-6.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.6,30c0-4.3,3.5-7.7,8.2-7.7s5.1,1.2,6.5,3l-2,2c-1-1.3-2.7-2.2-4.5-2.2-2.8,0-5,2.1-5,4.9s2.2,4.9,5,4.9,3.6-1,4.6-2.3l2,1.9c-1.3,1.9-3.9,3.1-6.6,3.1-4.6,0-8.2-3.4-8.2-7.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 169,
    y: 22.8,
    width: 3.2,
    height: 14.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.1,33.3v-7.8h-3.5v-2.7h3.6v-3.1l3-1.5v4.5h4.7v2.7h-4.7v7.3c0,1.5.8,2.1,2.4,2.1s1.5-.1,2.3-.5v2.7c-.8.4-1.8.6-2.9.6-2.8,0-4.9-1.5-4.9-4.4"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 188.4,
    y: 22.8,
    width: 3.2,
    height: 14.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResized2024MichelinPartnershipLogoLockup);
export default __webpack_public_path__ + "static/media/Resized_2024_MICHELIN_partnership_logo_lockup.d0084a8dab3e82cca6b480fc1f097c7a.svg";
export { ForwardRef as ReactComponent };